import './PatientsInformation.css';
import PatientSplitButton from './SplitButton';

const PatientsInformation = ({ format, patients, setPatients, placeholders, handleCallSelectedPatients, handleSMSSelectedPatients }) => {

    const addPatient = () => {
        const placeholderFields = placeholders.reduce((acc, ph) => {
            acc[ph] = '';
            return acc;
        }, {});
        
        const newPatient = {
            id: Date.now(),
            selected: true,
            name: '',
            phone_number: '',
            callTime: '',
            lang:'en',
            ...placeholderFields
        };
        setPatients([...patients, newPatient]);
    };

    const toggleSelectAll = () => {
        const allSelected = patients.every(p => p.selected);
        const updated = patients.map(p => ({ ...p, selected: !allSelected }));
        setPatients(updated);
    };

    const toggleSelect = (id) => {
        setPatients(patients.map(p => 
            p.id === id ? { ...p, selected: !p.selected } : p
        ));
    };

    const updateField = (id, field, value) => {
        setPatients(patients.map(p =>
            p.id === id ? { ...p, [field]: value } : p
        ));
    };

    const deletePatient = (id) => {
        setPatients(patients.filter(p => p.id !== id));
    };

    const isAllSelectedPatientsComplete = () => {
        const selectedPatients = patients.filter(p => p.selected);
        if (selectedPatients.length === 0) return false;

        return selectedPatients.every(p =>
            p.name.trim() &&
            p.phone_number.trim() &&
            placeholders.every(ph => (p[ph] || "").trim())
        );
    };

    const getDisabledTooltipMessage = () => {
        const selectedPatients = patients.filter(p => p.selected);
        if (selectedPatients.length === 0) {
            return "Please select at least 1 patient to call";
        }

        return "Please enter all values for selected patients";
    };

    const getMinDateTime = () => {
        const now = new Date();
        const pad = (n) => n.toString().padStart(2, '0');
        const yyyy = now.getFullYear();
        const mm = pad(now.getMonth() + 1);
        const dd = pad(now.getDate());
        const hh = pad(now.getHours());
        const min = pad(now.getMinutes());
        return `${yyyy}-${mm}-${dd}T${hh}:${min}`;
    };


    const allSelected = patients.length > 0 && patients.every(p => p.selected);

    return (
        <div className="patients-container">
            <div className="patients-header">
                <h3>Add Patients' Information</h3>
                {/* <div className="patients-tools">
                    <span className="filter-icon">🔍 Filter</span>
                    <input 
                        type="text" 
                        className="patients-search" 
                        placeholder="Search" 
                    />
                </div> */}
            </div>
            <table className="patients-table">
                <thead>
                    <tr>
                        <th><input type="checkbox" 
                            checked={allSelected} 
                            onChange={toggleSelectAll} 
                        /></th>
                        <th>Name</th>
                        <th>Phone No.</th>
                        <th>Send Time</th>
                        <th>Language</th>
                        {placeholders.map(ph => (
                            <th key={ph}>{ph}</th>
                        ))}
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {patients.map((p, index) => (
                        <tr key={p.id}>
                            <td>
                                <input 
                                    type="checkbox" 
                                    checked={p.selected || false} 
                                    onChange={() => toggleSelect(p.id)} 
                                />
                            </td>
                            <td>
                                <input
                                    type="text"
                                    placeholder="Enter name"
                                    value={p.name}
                                    onChange={(e) => updateField(p.id, 'name', e.target.value)}
                                    className="row-input"
                                />
                            </td>
                            <td>
                                <input
                                    type="text"
                                    placeholder="Enter phone"
                                    value={p.phone_number}
                                    onChange={(e) => updateField(p.id, 'phone_number', e.target.value)}
                                    className="row-input"
                                />
                            </td>
                            <td>
                                <input
                                    type="datetime-local"
                                    value={p.callTime}
                                    min={getMinDateTime()}
                                    onChange={(e) => updateField(p.id, 'callTime', e.target.value)}
                                    className="row-input"
                                />
                            </td>

                            <td>
                                <select 
                                    id="lang"
                                    name="lang"
                                    className="template-select"
                                    value={p.lang}
                                    onChange={(e) => updateField(p.id, 'lang', e.target.value)}
                                    >
                                    
                                    <option value="en">English</option>
                                    <option value="cn">Chinese</option>
                                    <option value="my">Malay</option>
                                    <option value="tm">Tamil</option>
                                    
                                </select>
                            </td>    
                            {placeholders.map(ph => (
                                <td key={ph}>
                                    <input
                                        type="text"
                                        placeholder={`Enter ${ph.replace(/[<>]/g, '').toLowerCase()}`}
                                        value={p[ph] || ''}
                                        onChange={(e) => updateField(p.id, ph, e.target.value)}
                                        className="row-input"
                                    />
                                </td>
                            ))}
                            <td>
                                <button className="delete-button" onClick={() => deletePatient(p.id)}>&#x2573;</button>
                            </td>
                        </tr>
                    ))}
                    <tr className="add-patient-row" onClick={addPatient}>
                        <td colSpan={4 + placeholders.length + 1}><b>+ Add Patient</b></td>
                    </tr>
                </tbody>
            </table>
            <div className="patients-footer">
                <span className="default-call-time-hint">
                    &#x24D8; Default Send Time is ASAP
                </span>
                {/* <div className="call-button-wrapper">
                    <button 
                        className="call-patients-button" 
                        onClick={() => handleCallSelectedPatients(patients, placeholders)}
                        disabled={!isAllSelectedPatientsComplete()}
                    >
                        <b>{format} Selected Patients</b>
                    </button>
                    {!isAllSelectedPatientsComplete() && (
                        <div className="button-tooltip">
                            {getDisabledTooltipMessage()}
                        </div>
                    )}
                </div> */}
                <PatientSplitButton
                    format={format}
                    patients={patients}
                    placeholders={placeholders}
                    handleCallSelectedPatients={handleCallSelectedPatients}
                    handleSMSSelectedPatients={handleSMSSelectedPatients}
                    getDisabledTooltipMessage={getDisabledTooltipMessage}
                    isAllSelectedPatientsComplete={isAllSelectedPatientsComplete}
                />
            </div>
        </div>
    );
};

export default PatientsInformation;